var moduleGlobalBanner = function() {
  var $ = jQuery,
      _this,
      LS_BANNER_SHOWN = 'globalBannerShown';

  var module = {
    init: function() {
      _this = this;
      this.modifyDOM();
      this.addEvents();
      var $banner = $('.js-global-banner');

      if (window.wp_global_banner_active && store.get(LS_BANNER_SHOWN) !== window.wp_global_banner_image_id) {
        $banner.modal();
      }
    },

    modifyDOM: function() {
    },

    addEvents: function() {
      $('.js-global-banner').on('hidden.bs.modal', _this.eventHandlers.bannerClosed);
    },

    eventHandlers: {
      bannerClosed: function(e) {
        store.set(LS_BANNER_SHOWN, window.wp_global_banner_image_id);
      }
    },

    helpers: {
    }
  };

  module.init();
};
